import { ReactElement, useMemo } from 'react';
import { FormFooterContainer } from './styles';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';
import { LoaderRing } from '~/components/LoaderRing';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormValues } from './types';
import { isFormChanged } from './constants';

interface FormFooterProps {
  defaultValues: FormValues;
  disabledSubmit: boolean;
  loading: boolean;
  onCancel?: () => void;
}

export function FormFooter({
  defaultValues,
  disabledSubmit,
  loading,
  onCancel,
}: Readonly<FormFooterProps>): ReactElement {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();

  const values = useWatch({
    control,
  }) as FormValues;

  const hasFormChanges = useMemo(() => isFormChanged(defaultValues, values),
    [defaultValues, values]);

  return (
    <FormFooterContainer>
      {onCancel !== undefined && (
        <Button
          variant="neutral-ghost"
          onClick={onCancel}
          type="button"
          disabled={loading}
        >
          {t('cancelar')}
        </Button>
      )}
      <Button
        variant="primary-filled"
        disabled={disabledSubmit || !hasFormChanges}
        {...(loading ? {
          type: 'button',
          onClick: () => { },
        } : {
          type: 'submit',
        })}
      >
        {loading ? (
          <LoaderRing size="small" />
        ) : t('salvar')}
      </Button>
    </FormFooterContainer>
  );
}
